import { useCallback, useState } from 'react'
import { VersionReportVersionEntity } from '../../../../domain/entity/version-report/VersionReportVersionEntity'

export type UseVersionSelectMenuReturnValue = ReturnType<
  typeof useVersionSelectMenu
>

export const useVersionSelectMenu = (
  updateVersionUuid: (uuid: string | undefined) => void
) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  const selectReport = useCallback(
    (report: VersionReportVersionEntity) => {
      updateVersionUuid(report.uuid)
      setIsOpen(false)
    },
    [updateVersionUuid]
  )

  const handleAfterCreateReport = useCallback(
    (uuid: string, _isInitial: boolean) => {
      updateVersionUuid(uuid)
      setIsOpen(false)
    },
    [updateVersionUuid]
  )

  return {
    isOpen,
    toggle,
    open,
    close,
    selectReport,
    handleAfterCreateReport,
  }
}
